
class SizeGuideDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );
      this.section = document.querySelector(`#${this.dataset.productInfo}`) || document.querySelector(`variant-swiper[data-product-id="${this.dataset.productId}"]`);
      this.querySelector('[id^="Drawer-Overlay"]').addEventListener(
        "click",
        this.close.bind(this)
      );
      this.setAccessibility();
      this.handleTabs();
      this.querySelector('.size-guide__cta button').addEventListener('click', this.onSubmit.bind(this));
      this.trackButtonSubmit()
    }
    setAccessibility() {
      const trigger = document.querySelector(`[data-drawer="${this.id}"]`);
      if (!trigger) return;
      trigger.setAttribute("role", "button");
      trigger.setAttribute("aria-haspopup", "dialog");
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        this.show(trigger);
      });
      trigger.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.show(trigger);
        }
      });
    } 
    onSubmit(e){
      let button = e.currentTarget
      button.setAttribute('disabled', true)
      this.section.querySelector('product-form form').dispatchEvent(new Event('submit'));
      subscribe(PUB_SUB_EVENTS.cartUpdate, ()=>{
          this.close()
          button.removeAttribute('disabled')
      })
      subscribe(PUB_SUB_EVENTS.cartError, ()=>{
          this.close()
          button.removeAttribute('disabled')
      })
    }
    activeOption(){
      let currentOptionEL = this.section.querySelector('.fieldset-size input:checked') || this.section.querySelector('.fieldset-talla input:checked');
      if(!currentOptionEL){
         currentOptionEL =  this.section.querySelector('.fieldset-size input') || this.section.querySelector('.fieldset-talla input')
      }
      let currentOption = currentOptionEL.value;
      if(currentOption){
          this.querySelector(`[data-value="${this.handle(currentOption)}"]`).dispatchEvent(new Event('click'));
      }
    }
    handleTabs(){
      this.querySelectorAll('.size-guide__tab').forEach((tab, index) => {
          tab.addEventListener('click', () => {
              this.querySelectorAll('.size-guide__tab').forEach(el => el.classList.remove('active'));
              tab.classList.add('active');
              this.querySelectorAll('.size-guide__content').forEach(el => el.classList.add('hidden'));
              this.querySelectorAll('.size-guide__content')[index].classList.remove('hidden');
           })
      })
    }
    handleSwiper(){
      if( this.swiperOption ) this.swiperOption.destroy();
      this.swiperOption = new Swiper(this.querySelector('.swiper'), {
          slidesPerView:'auto',
          spaceBetween: 8,
          mousewheel: true
      })
    }
  
    show(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      this.opening = true
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add("animate", "active");
      });
  
      this.addEventListener(
        "transitionend",
        () => {
          const focusElement =
            this.querySelector(".drawer__inner") ||
            this.querySelector(".drawer__close");
          trapFocus(this, focusElement);
          this.handleSwiper()
        },
        { once: true }
      );
  
      document.body.classList.add("overflow-hidden");
      this.querySelectorAll("[data-content-url]").forEach((e) => {
        let path = e.dataset.contentUrl;
        if (e.classList.contains("content-loaded")){
          this.activeOption()
          return;
        }
        this.renderContents(path, e);
      });
    }
  
    close() {
      this.classList.remove("active");
      removeTrapFocus(this.activeElement);
      document.body.classList.remove("overflow-hidden");
    }
    convertCSV(data) {
      // Split the CSV data into lines
      const lines = data.split("\n");
  
      // Extract the headers from the first line
      const headers = lines[0].split(",");
  
      // Convert the remaining lines into objects
      const items = lines.slice(1).map((line) => {
        const values = line.split(",");
        const item = {};
        headers.forEach((header, i) => {
          item[header.trim()] = values[i].trim();
        });
        return item;
      });
  
      // Now 'items' is an array of objects representing the CSV data
      let obj = {};
      items.forEach((item) => {
        let key = item.TALLA;
        delete item.TALLA;
        obj[key] = {
          ...item,
        };
      });
      return obj;
    }
  
    handleOptionClick(e){
      const value = e.currentTarget.dataset.value;
      const rows = this.querySelectorAll('.size-guide-table__row');
      this.querySelectorAll('.size-guide__option').forEach(el => el.classList.remove('active'));
      e.currentTarget.classList.add('active');
      rows.forEach(row => {
        if(row.dataset.option === value){
          row.classList.remove('hidden');
        }else{
          row.classList.add('hidden');
        }
      });
      let selectedOption = this.section.querySelector(`.fieldset-size input[value="${e.currentTarget.textContent.trim()}"`) || this.section.querySelector(`.fieldset-talla input[value="${e.currentTarget.textContent.trim()}"`);
      if(selectedOption){
          selectedOption.checked = true;
          if(this.section.querySelector('product-variant-radius')){
            this.section.querySelector('product-variant-radius').dispatchEvent(new Event('change'));
          }
          if(this.section.querySelector('variant-radios-pdf')){
            this.section.querySelector('variant-radios-pdf').onVariantChange();
          }
         
          // setTimeout(()=>{
        
  
          // observer.observe(submitButton, { attributes: true });
          // this.querySelector('.size-guide__cta button').setAttribute('disabled', true)
          //     if(submitButton.getAttribute('disabled')){
          //         this.querySelector('.size-guide__cta button').setAttribute('disabled', true)
          //     } else {    
          //         this.querySelector('.size-guide__cta button').removeAttribute('disabled')
          //     }
          //     this.querySelector('.size-guide__cta button').innerHTML = submitButton.innerHTML
          // }, 1200)
      }
      
    }
    renderContents(path, element) {
      fetch(path)
        .then((response) => response.text())
        .then((data) => {
          const html = document.createElement("div");
          let obj = this.convertCSV(data);
          if (obj) {
            element.innerHTML = this.renderData(obj, element);
            element.classList.add("content-loaded");
            this.querySelectorAll('.size-guide__option').forEach(el => el.addEventListener('click', this.handleOptionClick.bind(this)));
            this.activeOption()
          //   this.querySelector('.size-guide__option').dispatchEvent(new Event('click'));
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
    trackButtonSubmit(){
      let submitButton = this.section.querySelector('.product-form__submit[name="add"]');
      console.log(submitButton)
      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
            const submitButton = this.section.querySelector('.product-form__submit[name="add"]');
            const sizeGuideButtons = this.querySelectorAll('.size-guide__cta button');
            
            sizeGuideButtons.forEach(sizeGuideButton => {
              if (submitButton.getAttribute('disabled')) {
                sizeGuideButton.setAttribute('disabled', true);
              } else {
                sizeGuideButton.removeAttribute('disabled');
              }
              sizeGuideButton.innerHTML = submitButton.innerHTML
            });
          }
        }
      });
      observer.observe(submitButton, { attributes: true });
    }
    handle(str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)+/g, "");
    }
    convertCmToInch(cm) {
      cm = parseFloat(cm);
      const inch = cm / 2.54;
      return Math.floor(inch)
    }
  
    renderData(obj, element) {
      let rows = Object.keys(obj).map((key) => {
          let valueCols = Object.entries(obj[key]).map(([k, v]) => { 
              return `<div class="size-guide-table__row hidden" data-option="${this.handle(key)}"><div class="size-guide-table__col">
                               ${k}
               </div>
              <div class="size-guide-table__col  center size-guide-table__col--cm">
                              ${v}
              </div>
          <div class="size-guide-table__col  center size-guide-table__col--inch">
              ${ v && v.split('-').map(cm => this.convertCmToInch(cm) ).join('-') }
          </div>
              </div>`;
          });
        return `${valueCols.join("")}`;
      });
      let header = element.dataset.label.split(',').map((label,i) =>{
          return `<div class="size-guide-table__col ${i > 0 ? ' center' : ''}"> ${ label.trim() }
          </div> `
      })
      let html = `<div class="size-guide-table">
      <div class="size-guide-table__header">
             ${header.join("")}
              </div>
              ${rows.join("")}
      </div>`;
      return html;
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define("size-guide-drawer", SizeGuideDrawer);
  